export enum InvoiceType {
  GrossInvoice = 'GrossInvoice',
  NetInvoice = 'NetInvoice',
}
